import { DatePicker, Form, message } from "antd";

import moment from "moment";
import "./submitToBilling.scss";
import {
  disabledDatesPriorMonth,
} from "utilities/dateUtility";
import BillingApproval from "redux/models/billingApproval";
import K from "utilities/constants";

const {
  Invoice: { Type },
} = K;

export default function CreateInvoice({
  form,
  invoicePayloadRef,
  setLoading,
  setPageStates,
}) {

  const createBillingInvoice = async (values) => {
    setLoading(true);
    const { index, ...payload } = invoicePayloadRef.current;
    payload.dueDate = values.dueDate.format(K.DateFormat.Response);

    const invoicebody = {
      clientId: payload.clientId,
      type: payload.type,
      dueDate: payload.dueDate,
      selectAll: payload.selectAll,
      toggledNodes: payload.submittalBillIds,
    };
    try {
      const res = await BillingApproval.generateInvoice(invoicebody);
      message.success(res.message);
      setPageStates((prev) => ({
        ...prev,
        clientLoading: payload.type === Type.Client,
        isDueDateModalVisible: false,
      }));
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <Form layout="vertical" form={form} onFinish={createBillingInvoice}>
      <Form.Item
        label="Invoice Draft Date"
        name="dueDate"
        initialValue={moment()}
        rules={[{ required: true, message: "Please select due date" }]}
      >
        <DatePicker
          disabledDate={disabledDatesPriorMonth}
          placeholder="Due Date"
          format={K.DateFormat.DashUSFormat}
        />
      </Form.Item>
    </Form>
  );
}
